module.exports = __webpack_public_path__ + "assets/certificate_pdf/DeepLearningInstitute-DUKE.b748cd46.pdf";